import type { GetSleepTimeArgs } from './usePolling.types';

export const getSleepTime = ({
  requestsCount,
  delayUnit,
  maxTime,
  maxAttemptsBeforeDelay,
}: GetSleepTimeArgs) => {
  const min = Math.max(delayUnit * (requestsCount - maxAttemptsBeforeDelay), 0);

  return Math.min(min, maxTime);
};

export const sleep = (ms: number, signal?: AbortSignal): Promise<void> => {
  return new Promise((resolve, reject) => {
    const timeout = setTimeout(() => {
      cleanup();
      resolve();
    }, ms);

    const onAbort = () => {
      clearTimeout(timeout);
      cleanup();
      reject(new DOMException('Aborted', 'AbortError'));
    };

    const cleanup = () => {
      signal?.removeEventListener('abort', onAbort);
    };

    if (signal?.aborted) {
      onAbort();
    } else {
      signal?.addEventListener('abort', onAbort);
    }
  });
};

export const isAbortError = (err: unknown) =>
  (err instanceof Error && err.name === 'AbortError') ||
  (err instanceof DOMException && err.name === 'AbortError');
